(function(g){
    $data.setModelContainer(g);
    g.Container = $data.Container;
    g.Guard = $data.Guard;
    g.$C = $data.$C;
    g.Exception = $data.Exception;
    g.MemberDefinition = $data.MemberDefinition;
})(window);